import { useState, useCallback } from 'react';
import {
    createReportWorkerReportPost,
    CreateReportWorkerReportPostData,
    GetMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGetData,
    getMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGet,
    GetReportByAdminAdminReportReportIdGetData,
    getReportByAdminAdminReportReportIdGet,
    AdminUpdateReportAdminReportReportIdPutData,
    adminUpdateReportAdminReportReportIdPut,
    DeleteFileEndpointCommonDeleteFileDeleteData,
    deleteFileEndpointCommonDeleteFileDelete,
    getImageUploadUrlCommonReportImageUploadUrlPost,
    GetImageUploadUrlCommonReportImageUploadUrlPostData,
    DownloadPdfAdminReportIdPdfDownloadGetData,
    downloadPdfAdminReportIdPdfDownloadGet,
    adminDeleteReportAdminReportReportIdDelete,
    ToggleReportStatusAdminReportReportIdStatusPatchData,
    toggleReportStatusAdminReportReportIdStatusPatch,
    toggleSalesStatusAdminReportReportIdSalesStatusPatch,
    ToggleSalesStatusAdminReportReportIdSalesStatusPatchData,
    restoreReportAdminReportReportIdRestorePost,
    RestoreReportAdminReportReportIdRestorePostData,
} from "../client";

export const useReport = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const createReport = useCallback(async (data: CreateReportWorkerReportPostData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await createReportWorkerReportPost(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);


    const getReportById = useCallback(async (data: GetReportByAdminAdminReportReportIdGetData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getReportByAdminAdminReportReportIdGet(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const updateReport = useCallback(async (data: AdminUpdateReportAdminReportReportIdPutData) => {
        console.log(data);
        setLoading(true);
        setError(null);
        try {
            console.log(data);
            const response = await adminUpdateReportAdminReportReportIdPut(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const updateReportStatus = useCallback(async (data: ToggleReportStatusAdminReportReportIdStatusPatchData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await toggleReportStatusAdminReportReportIdStatusPatch(data);
            return response;
        } catch (error: any) {
            // 呼び出し元(各reportXxxDetail.tsx)がtry/catchで失敗時の表示を行う前提のため、
            // ここでエラーを握り潰さずに再throwする。握り潰すと呼び出し元のcatchが
            // 発火せず、APIが失敗してもUI上は成功したように見えてしまう。
            setError(error.message);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    const updateReportSalesStatus = useCallback(async (data: ToggleSalesStatusAdminReportReportIdSalesStatusPatchData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await toggleSalesStatusAdminReportReportIdSalesStatusPatch(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            throw error;
        } finally {
            setLoading(false);
        }
    }, []);

    const getReportListByType = useCallback(async (data: GetMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGetData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getMinimalReportsByTypeAdminReportsTypeReportTypeMinimalGet(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const getImageUploadUrl = useCallback(async (data: GetImageUploadUrlCommonReportImageUploadUrlPostData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await getImageUploadUrlCommonReportImageUploadUrlPost(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const deleteFile = useCallback(async (data: DeleteFileEndpointCommonDeleteFileDeleteData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await deleteFileEndpointCommonDeleteFileDelete(data);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const downloadAirconPdf = useCallback(async (data: DownloadPdfAdminReportIdPdfDownloadGetData) => {
        setLoading(true);
        setError(null);
        try {
            const response = await downloadPdfAdminReportIdPdfDownloadGet(data);
            console.log(response);
            return response;
        } catch (error: any) {
            setError(error.message);
            return null;
        } finally {
            setLoading(false);
        }
    }, []);

    const deleteReport = useCallback(async (reportId: number) => {
        setLoading(true);
        setError(null);
        try {
            await adminDeleteReportAdminReportReportIdDelete({ reportId });
            return true;
        } catch (error: any) {
            setError(error.message);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    const restoreReport = useCallback(async (reportId: number) => {
        setLoading(true);
        setError(null);
        try {
            const response = await restoreReportAdminReportReportIdRestorePost({ reportId });
            return response ? true : false;
        } catch (error: any) {
            setError(error.message);
            return false;
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        loading,
        error,
        getImageUploadUrl,
        deleteFile,
        createReport,
        getReportById,
        updateReport,
        updateReportStatus,
        updateReportSalesStatus,
        deleteReport,
        restoreReport,
        getReportListByType,
        downloadAirconPdf,
    };
};

export default useReport;